import { ApiService } from '../services/api_service';
import { DataService } from '../services/data_service';
import { getDefaultKennzahlenDefinition } from '../helpers/getDefaultKennzahlenDefinition';
import { IDs } from '../helpers/IDs';
import { lazyInject } from '../services/inversify';
import { TriggerService } from '../core/trigger/trigger_service';

export class AdminMainLoader {

    constructor(callback: (data: any) => void) {
        this.dataLoaded = this.dataLoaded.bind(this);
        this.processCall = this.processCall.bind(this);
        this.modul = IDs.MOD_ETOOL_ADMIN;
        this.callback = callback;
        this.devFeaturesMap = require('../wips.config.js').devFeaturesMap || {};
    }

    private loadGoal = 0;
    private loadCnt = 0;
    private data: any = {};
    private modul: string;
    private callback: (data: any) => void;
    private devFeaturesMap: any = {};

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private start: number;

    loadData(): void {
        this.start = new Date().getTime();
        const loadInfo = [
            { entity: IDs.ENT_BRANCHEN, filter: {}, settings: {}, module: IDs.MOD_ETOOL_ADMIN },
            { entity: IDs.ENT_BRANCHEN_BEREICHE, filter: {}, settings: {}, module: IDs.MOD_ETOOL_ADMIN },
            { entity: IDs.ENT_BRANCHEN_GEWERKE, filter: {}, settings: { resolve: true }, module: IDs.MOD_ETOOL_ADMIN },
            { entity: IDs.ENT_GEWERKE_WZ, filter: {}, settings: { resolve: true }, module: IDs.MOD_ETOOL_ADMIN },
            { entity: IDs.ENT_GEWERKE_GRUPPE, filter: {}, settings: { resolve: true }, module: IDs.MOD_ETOOL_ADMIN },
            { entity: IDs.ENT_BUNDESLAND, filter: {}, settings: { resolve: true }, module: IDs.MOD_ETOOL_ADMIN },
            { entity: IDs.ENT_CO2_FAKTOREN_INTERN, filter: {}, settings: {}, module: IDs.MOD_ETOOL_ADMIN },
            { entity: IDs.ENT_KLIMAGASE_ART, filter: {}, settings: {}, module: IDs.MOD_ETOOL_ADMIN },
            { entity: IDs.ENT_CO2_FAKTOREN_KLIMAGASE, filter: {}, settings: {}, module: IDs.MOD_ETOOL_ADMIN },
            { entity: IDs.ENT_ERZEUGUNGS_LASTDATEN, filter: {}, settings: {}, module: IDs.MOD_ETOOL_ADMIN },
            { entity: IDs.ENT_GTZ_ORTE, filter: {}, settings: {}, module: IDs.MOD_ETOOL_ADMIN },
            { entity: IDs.ENT_KENNZAHLEN_DEFINTION, filter: {}, settings: {}, module: IDs.MOD_ETOOL_ADMIN },
            { entity: IDs.ENT_KENNZAHLEN_WERTE_AGGREGATION, filter: {}, settings: {}, module: IDs.MOD_ETOOL_ADMIN },
            { entity: IDs.ENT_KENNZAHLEN_WERTE_ZENTRAL, filter: {}, settings: {}, module: IDs.MOD_ETOOL_ADMIN },
            { entity: IDs.ENT_NACE, filter: {}, settings: {}, module: IDs.MOD_ETOOL_ADMIN },
            { entity: IDs.ENT_PARAMETER_HEIZWERTE, filter: {}, settings: {}, module: IDs.MOD_ETOOL_ADMIN },
            { entity: IDs.ENT_SYSTEMPARAMETER, filter: {}, settings: {}, module: IDs.MOD_ETOOL_ADMIN },
            { entity: IDs.ENT_KONTAKTE, filter: {}, settings: {}, module: IDs.MOD_ETOOL_ADMIN },
            { entity: IDs.ENT_KONTAKT_FAQ, filter: {}, settings: {}, module: IDs.MOD_ETOOL_ADMIN },
            { entity: IDs.ENT_UNTERNEHMEN, filter: {}, settings: {}, module: IDs.MOD_ETOOL_ADMIN },
            { entity: IDs.ENT_MANDANTEN_USER, filter: {}, settings: {}, module: IDs.MOD_ETOOL_ADMIN },
            { entity: IDs.ENT_REGISTRIERUNG, filter: {}, settings: {}, module: IDs.MOD_ETOOL_ADMIN },
            { entity: IDs.ENT_GROUP_ITEMS, filter: {}, settings: {}, module: IDs.MOD_LEGACY },
            { entity: IDs.ENT_BERATERZUORDNUNG, filter: {}, settings: {}, module: IDs.MOD_ETOOL_ADMIN },
            { entity: IDs.ENT_BERATER, filter: {}, settings: {}, module: IDs.MOD_ETOOL_ADMIN },
            { entity: IDs.ENT_VERBAND_ZUORDNUNG, filter: {}, settings: {}, module: IDs.MOD_ETOOL_ADMIN },
            { entity: IDs.ENT_FOERDERUNG, filter: {}, settings: {}, module: IDs.MOD_ETOOL_ADMIN },
            { entity: IDs.ENT_PARTNER, filter: {}, settings: {}, module: IDs.MOD_ETOOL_ADMIN },
            { entity: IDs.ENT_ZERTIFIZIERUNGSOPTIONEN, filter: {}, settings: {}, module: IDs.MOD_ETOOL },
            { entity: IDs.ENT_SYSTEMTEXTE, filter: {}, settings: { resolve: true }, module: IDs.MOD_ETOOL_ADMIN },
            { entity: IDs.ENT_SYSTEMTEXTE_ZUORDNUNG, filter: {}, settings: {}, module: IDs.MOD_ETOOL_ADMIN }
            // { entity: IDs.ENT_MAIL, filter: {}, settings: {}, module: IDs.MOD_ETOOL_ADMIN },
            // { entity: IDs.ENT_AKTUELLE_NACHRICHTEN, filter: {}, settings: {}, module: IDs.MOD_ETOOL_ADMIN }
        ];

        if (this.devFeaturesMap.N207_MEHRSPRACHIGKEIT) {
            loadInfo.push({ entity: IDs.ENT_MEHRSPRACHIGKEIT, filter: {}, settings: {}, module: IDs.MOD_ETOOL_ADMIN });
        }
        this.loadGoal = loadInfo.length;
        loadInfo.map((i: any) => this.processCall(i.entity, i.method, i.filter, i.settings, i.module, this.dataLoaded));
    }

    processCall(
        entity: any, method: string, filter: any, settings: any, module: string, callback: (obj: any, entity: string) => void,
        isReload = false
    ): void {
        const mod_use = module ? module : this.modul;

        if (!isReload) {
            // Hier registrieren wir uns mit der Entity beim Trigger-Service.
            // damit können wir bei Änderungen der Entity automatisch nur diese Reloaden
            this.triggerService.register('admin_reload', entity, (cbFromCaller?: (data: any) => void) => {
                console.log('AdminMainLoader: Reloading ' + entity);
                this.processCall(entity, method, filter, settings, module, this.dataLoaded, true);
                if (typeof cbFromCaller === 'function') {
                    cbFromCaller(this.data[entity]);
                }
            });
        }

        if (method) {
            this.apiService.call(
                method,
                {
                    module: mod_use,
                    override: 1,
                    filter,
                    settings
                },
                (json: string, suc: boolean) => {
                    if (suc) {
                        let obj: any;
                        try {
                            obj = JSON.parse(json);
                        } catch (e) {
                            console.error(e, json);
                        }
                        if (obj) {
                            if (typeof entity === 'string') {
                                callback(obj, entity);
                            } else if (Array.isArray(entity)) {
                                entity.forEach((ent: string) => {
                                    callback(obj, ent);
                                });
                            }
                        }
                    }
                }
            );
        } else {
            this.dataService.loadData(entity, filter, { resolve: true, bundle: true, ...settings }, callback, mod_use);
        }
    }

    dataLoaded(result: any, entityName: string): void {
        this.data[entityName] = result[entityName];

        if (entityName === IDs.ENT_KENNZAHLEN_DEFINTION) {
            const defaultKennzahlen = getDefaultKennzahlenDefinition()
            if (!this.data[entityName] || this.data[entityName].length === 0) {
                // Wenn nicht vorhanden --> Alle einfügen
                this.data[entityName] = defaultKennzahlen;
                // console.log('Benutze Standard-Kennziffern ...');
            } else {
                // Sonst nur die fehlenden ergänzen
                defaultKennzahlen.forEach((kz: any) => {
                    if (!this.data[entityName].some((kz_check: any) => kz.kuerzel === kz_check.kuerzel)) {
                        this.data[entityName].push(kz);
                    }
                });
            }
        }

        if (result.bundle) {
            this.data[`${entityName}_bundle`] = result.bundle;
        }
        this.loadCnt++;

        if (this.loadCnt >= this.loadGoal) { // Wir prüfen mit >= da spätere Reloads den Count nochmal erhöhen
            console.log(`Laden fertig nach: ${(new Date().getTime() - this.start)} ms`);
            this.process();
        }
    }

    process(): void {
        this.callback(this.data);
        // console.log(this.data);
    }
}
